(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["HS-Bestseller"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('form.hs-quick-form').forEach(function (form) {
  if (form.dataset.hsBound) return;
  form.dataset.hsBound = '1';
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = form.querySelector('button');
    var idField = form.querySelector("[name='id']");
    if (!idField) return;
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: idField.value, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = 'Added'; }
        document.dispatchEvent(new CustomEvent('hs:cart:added'));
        setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1400);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        form.submit();
      });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-event"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initEventIndex(root) {
    if (!root || root.dataset.hsEiBound) return;
    root.dataset.hsEiBound = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ei-tab]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ei-slide]'));
    var panel = root.querySelector('[role="tabpanel"]');
    var cta = root.querySelector('[data-hs-ei-cta]');
    var ctaName = root.querySelector('[data-hs-ei-cta-name]');
    if (!tabs.length || !slides.length) return;

    var hoverOn = root.dataset.hover === 'true';
    var current = 0;

    function activate(i, focusIt) {
      if (i < 0) i = tabs.length - 1;
      if (i >= tabs.length) i = 0;
      current = i;

      tabs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });

      slides.forEach(function (s, n) {
        var on = n === i;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });

      var active = tabs[i];
      if (panel && active.id) panel.setAttribute('aria-labelledby', active.id);
      if (cta) {
        var url = active.getAttribute('data-url') || '#';
        cta.setAttribute('href', url);
        if (ctaName) ctaName.textContent = active.getAttribute('data-name') || '';
      }
      if (focusIt) active.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        if (i === current && cta) {
          var url = tab.getAttribute('data-url');
          if (url && url !== '#') { window.location.href = url; return; }
        }
        activate(i, false);
      });

      if (hoverOn && window.matchMedia('(hover: hover) and (min-width: 901px)').matches) {
        tab.addEventListener('mouseenter', function () { activate(i, false); });
      }

      tab.addEventListener('keydown', function (e) {
        var k = e.key;
        if (k === 'ArrowDown' || k === 'ArrowRight') { e.preventDefault(); activate(current + 1, true); }
        else if (k === 'ArrowUp' || k === 'ArrowLeft') { e.preventDefault(); activate(current - 1, true); }
        else if (k === 'Home') { e.preventDefault(); activate(0, true); }
        else if (k === 'End') { e.preventDefault(); activate(tabs.length - 1, true); }
      });
    });

    activate(0, false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hs-ei]').forEach(initEventIndex);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-pdp-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(cents) {
    try {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function initPdp(root) {
    if (!root || root.dataset.hsPdpBound) return;
    root.dataset.hsPdpBound = '1';

    /* ---- Gallery ---- */
    var slides = root.querySelectorAll('[data-hs-slide]');
    var thumbs = root.querySelectorAll('[data-hs-thumb]');
    function showSlide(i) {
      slides.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { showSlide(i); });
    });

    /* ---- Quantity ---- */
    var qtyInput = root.querySelector('[data-hs-qtyinput]');
    root.querySelectorAll('[data-hs-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(b.getAttribute('data-hs-qty'), 10);
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v + step);
      });
    });

    /* ---- Gift message counter ---- */
    var msg = root.querySelector('[data-hs-msg]');
    var msgCount = root.querySelector('[data-hs-msgcount]');
    if (msg && msgCount) {
      msg.addEventListener('input', function () { msgCount.textContent = msg.value.length; });
    }

    /* ---- Delivery date minimum ---- */
    var dateEl = root.querySelector('[data-hs-date]');
    if (dateEl) {
      var lead = parseInt(dateEl.getAttribute('data-lead'), 10) || 0;
      var d = new Date();
      d.setDate(d.getDate() + lead);
      var iso = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      dateEl.setAttribute('min', iso);
    }

    /* ---- Variants ---- */
    var dataEl = root.querySelector('[data-hs-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var idField = root.querySelector('[data-hs-id]');
    var priceEl = root.querySelector('[data-hs-price]');
    var wasEl = root.querySelector('[data-hs-was]');
    var addBtn = root.querySelector('[data-hs-add]');
    var addText = root.querySelector('[data-hs-addtext]');
    var soldLabel = (addBtn && addBtn.getAttribute('data-sold')) || 'Sold out';
    var addLabel = (addBtn && addBtn.getAttribute('data-add')) || 'Add to bag';
    var optGroups = root.querySelectorAll('[data-hs-opt]');
    if (!optGroups.length) return;

    function selectedValues() {
      var vals = [];
      optGroups.forEach(function (g) {
        var checked = g.querySelector('input:checked');
        vals.push(checked ? checked.value : null);
      });
      return vals;
    }

    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var n = 0; n < vals.length; n++) {
          if (vals[n] === null) { ok = false; break; }
          if (v['option' + (n + 1)] !== vals[n]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function markUnavailable(vals) {
      optGroups.forEach(function (g, gi) {
        g.querySelectorAll('[data-hs-optinput]').forEach(function (input) {
          var trial = vals.slice();
          trial[gi] = input.value;
          var match = null;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i], ok = true;
            for (var n = 0; n < trial.length; n++) {
              if (trial[n] === null) continue;
              if (v['option' + (n + 1)] !== trial[n]) { ok = false; break; }
            }
            if (ok) { match = v; break; }
          }
          var label = input.closest('.hs-pdp__swatch');
          if (label) label.classList.toggle('is-out', !(match && match.available));
        });
      });
    }

    function update() {
      var vals = selectedValues();
      var v = findVariant(vals);
      markUnavailable(vals);

      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addText) addText.textContent = 'Unavailable';
        return;
      }

      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          wasEl.textContent = money(v.compare_at_price);
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      }
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? addLabel : soldLabel;

      if (v.featured_image && v.featured_image.position) {
        showSlide(v.featured_image.position - 1);
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    root.querySelectorAll('[data-hs-optinput]').forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hs-pdp]').forEach(initPdp);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
